import { render, staticRenderFns } from "./SolutionRender.vue?vue&type=template&id=3c2c5b5e&scoped=true&"
import script from "./SolutionRender.vue?vue&type=script&lang=ts&"
export * from "./SolutionRender.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionRender.vue?vue&type=style&index=0&id=3c2c5b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c5b5e",
  null
  
)

export default component.exports